import { useCallback, useMemo } from 'react'

import { useQuery } from '@shared/modules/use-query/hooks'
import { UseQueryOptions } from '@shared/modules/use-query/types'
import { ProductsService } from '../services'
import { ProductMappers } from '../mappers'
import { ProductFormData, ProductType } from '../types'

export const useProductInitialValues = (id?: string) => {
  const initialValues = useMemo<ProductFormData>(
    () => ({
      id,
      barcode: '',
      itemCode: '',
      categoryId: '',
      criticalThreshold: 0,
      descr: '',
      hasExpiryDate: false,
      manufacturerCountryId: '',
      measurementUnitId: '',
      productName: '',
      statusId: '6',
      type: ProductType.PRODUCT,
    }),
    [id],
  )

  return useQuery(
    useCallback(async () => {
      const result = await ProductsService.getOneById(id || 0)
      if (result.status === 200) {
        return ProductMappers.formInitializer(result.data)
      } else {
        throw new Error(result.data)
      }
    }, [id]),
    useMemo<UseQueryOptions>(
      () => ({
        initialData: initialValues,
        enabled: !!id,
      }),
      [id, initialValues],
    ),
  )
}
